module.exports = __webpack_public_path__ + "media/images/flags/1x1/vir-2d791534df1775344374bade01ca10ef.svg";